/* tslint:disable */
/* eslint-disable */
/**
 * Viterbit API
 * This is the documentation for viterbit\'s apps
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateJobPositionCommand
 */
export interface CreateJobPositionCommand {
    /**
     * 
     * @type {string}
     * @memberof CreateJobPositionCommand
     */
    name?: string;
}

/**
 * Check if a given object implements the CreateJobPositionCommand interface.
 */
export function instanceOfCreateJobPositionCommand(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CreateJobPositionCommandFromJSON(json: any): CreateJobPositionCommand {
    return CreateJobPositionCommandFromJSONTyped(json, false);
}

export function CreateJobPositionCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateJobPositionCommand {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function CreateJobPositionCommandToJSON(value?: CreateJobPositionCommand | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
    };
}

